/* eslint-disable import/no-extraneous-dependencies */
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
/* eslint-enable import/no-extraneous-dependencies */

// Brand colors
const BRAND_COLORS = [
  '#F44336', // puzzle-red
  '#FFC107', // puzzle-yellow
  '#4CAF50', // puzzle-green
  '#2196F3', // puzzle-blue
];

// Get random brand color
const getRandomColor = () => BRAND_COLORS[Math.floor(Math.random() * BRAND_COLORS.length)];

// Configure NProgress
NProgress.configure({
  showSpinner: false,
  trickleSpeed: 200,
  minimum: 0.1,
});

// Set random color on start
export const startProgress = () => {
  const color = getRandomColor();
  document.documentElement.style.setProperty('--nprogress-color', color);
  NProgress.start();
};

export const doneProgress = () => NProgress.done();
export const incProgress = () => NProgress.inc();

export default NProgress;
